"use strict";

const $ = require("./main.js");

$(document).ready(function ($) {

});


